import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "size-8 md:size-[34px] flex items-center justify-center rounded-full bg-brown" }
const _hoisted_2 = { class: "flex-1 hidden md:block" }


import ArrowIcon from "@/components/icons/ArrowIcon.vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'BackButton',
  emits: ["clicked"],
  setup(__props) {

const { t } = useI18n();



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "group relative flex items-center h-8 w-8 md:h-[44px] md:w-[164px] md:px-[5px] rounded-full border border-brown text-brown font-medium text-base leading-[20px]",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clicked')))
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createVNode(ArrowIcon, { class: "text-white -rotate-[135deg]" })
    ]),
    _createElementVNode("span", _hoisted_2, [
      _renderSlot(_ctx.$slots, "back-text", {}, () => [
        _createTextVNode(_toDisplayString(_unref(t)("buttons.back")), 1)
      ])
    ])
  ]))
}
}

})